<template>
  <div class="bindingAccount" @keydown.enter="handleSubmit">
    <div class="header">
      <div class="title">绑定账号</div>
      <div class="close-btn" @click="gotoLogin">
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-arrow-left-circle"></use>
        </svg>
      </div>
    </div>
    <el-form
      class="user-layout-login"
      ref="bindForm"
      :model="formData"
      :rules="rules"
    >
      <el-form-item prop="account">
        <el-input
          :oninput="(formData.account = formData.account.replace(/[^\d]/g, ''))"
          v-model.trim="formData.account"
          maxlength="11"
          placeholder="11位手机号"
          @input="checkPhone"
        >
          <template #prefix>
            <svg
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <use xlink:href="#icon-shouji1"></use>
            </svg>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password" v-if="!isRegister">
        <el-input
          autocomplete="off"
          :type="isShowPassword ? 'text' : 'password'"
          maxLength="12"
          placeholder="请输入6-12位密码"
          v-model.trim="formData.password"
        >
          <template #prefix>
            <svg
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <use xlink:href="#icon-mima"></use>
            </svg>
          </template>
          <svg
            class="show-password"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            slot="suffix"
            @click="isShowPassword = !isShowPassword"
          >
            <use
              :xlink:href="isShowPassword ? '#icon-browse' : '#icon-eye-close'"
            ></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item prop="repassword" v-if="!isRegister">
        <el-input
          autocomplete="off"
          :type="isShowRePassword ? 'text' : 'password'"
          maxLength="12"
          placeholder="确认密码"
          v-model.trim="formData.repassword"
        >
          <template #prefix>
            <svg
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <use xlink:href="#icon-mima"></use>
            </svg>
          </template>
          <svg
            class="show-password"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            slot="suffix"
            @click="isShowRePassword = !isShowRePassword"
          >
            <use
              :xlink:href="
                isShowRePassword ? '#icon-browse' : '#icon-eye-close'
              "
            ></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item prop="captcha">
        <el-col :span="14">
          <el-input
            type="text"
            autocomplete="off"
            maxLength="6"
            placeholder="验证码"
            v-model.trim="formData.captcha"
          >
            <template #prefix>
              <svg
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
              >
                <use xlink:href="#icon-yanzhengma"></use>
              </svg>
            </template>
          </el-input>
        </el-col>
        <el-col :span="9" :offset="1">
          <el-button
            class="getCaptcha"
            type="primary"
            :disabled="state.smsSendBtn || isBind"
            @click.stop.prevent="getCaptcha($event)"
            v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
          ></el-button>
        </el-col>
      </el-form-item>
      <el-form-item class="agreement" v-if="!isRegister">
        <el-checkbox v-model="formData.isAngree"> 已阅读并同意 </el-checkbox>
        <span class="user-rule-button" @click.stop="onClickRule"
          >《用户协议》</span
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn || isBind"
          @click="handleSubmit"
          v-text="isRegister ? '确认' : '注册并绑定'"
        ></el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  validatePhone,
  validatePassword,
  validateCaptcha
} from '@/utils/rules'
import md5 from 'md5'
import { isExist, getSmsCaptcha, register, bind } from '@/api/login'
import { setToken } from '@/utils/auth'
import {
  inviteMemberApi,
  detectTeam,
  switchTeam,
  teamListSelect
} from '@/api/teamManagement'

export default {
  name: 'BindingAccount',
  props: ['openId'],
  data () {
    return {
      isRegister: true,
      isBind: false,
      type: 1,
      isShowPassword: false,
      isShowRePassword: false,
      rules: {
        account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        repassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          // { validator: validatePassword, trigger: 'blur' },
          { validator: this.handlePasswordCheck, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCaptcha, trigger: 'blur' }
        ]
      },
      formData: {
        account: '',
        password: '',
        captcha: '',
        repassword: '',
        isAngree: false
      },
      state: {
        time: 60,
        loginBtn: false,
        smsSendBtn: false,
        grant_type: 'password'
      }
    }
  },
  methods: {
    handlePasswordCheck (rule, value, callback) {
      const { password } = this.formData
      if (value === undefined) {
        callback(new Error('请再次输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    // 验证手机号是否注册
    checkPhone (value) {
      if (value.length === 11) {
        this.$refs.bindForm.validateField('account', async (errorMsg) => {
          if (!errorMsg) {
            const { data } = await isExist(this.formData.account)
            if (this.type === 1) {
              if (!data) {
                this.$refs.bindForm.clearValidate()
                this.type = 2
                this.isRegister = false
                this.isBind = false
                this.$message.warning(
                  '该手机号暂未注册，请输入密码完成注册并绑定!'
                )
              } else {
                this.isRegister = true
                if (data.relevanceThirdPlatform[0]) {
                  this.isBind = true
                  this.$message.warning('该账号已绑定，请重新输入手机号!')
                } else {
                  this.isBind = false
                }
              }
            } else if (this.type === 2) {
              if (data) {
                if (data.relevanceThirdPlatform[0]) {
                  this.isBind = true
                  this.$message.warning('该账号已绑定，请重新输入手机号!')
                } else {
                  this.$refs.bindForm.clearValidate()
                  this.isBind = false
                  this.type = 1
                  this.isRegister = true
                  this.$message.warning('该手机号已注册, 请直接绑定!')
                }
              } else {
                this.isRegister = false
              }
            }
          }
        })
      }
    },

    // 通过邀请链接扫码登录
    async inviteMem (msg) {
      // 判断是否是通过邀请链接注册
      let { teamId, noncestr } = this.$route.query
      teamId = Number(teamId)
      if (noncestr) {
        // 通过邀请链接注册
        const { data } = await this.GetInfo()
        const userId = data.id
        const res = await detectTeam({ teamId, userId })
        if (res.data) {
          const res = await teamListSelect()
          await switchTeam({ teamId: res.data[0].id })

          this.$message.warning('你已加入该团队!')
          this.$router.push({ path: '/controlPlatform' })
        } else {
          await inviteMemberApi({ noncestr })
          const res = await teamListSelect()
          await switchTeam({ teamId: res.data[0].id })

          this.$message.success('加入团队成功!')
          this.$router.push({ path: '/controlPlatform' })
        }
      } else {
        // 直接绑定 或 注册并绑定
        const res = await teamListSelect()
        await switchTeam({ teamId: res.data[0].id })

        this.$message.success(msg)
        // localStorage.removeItem('account')
        // localStorage.removeItem('password')
        this.$router.push({ path: '/controlPlatform' })
      }
    },

    async handleSubmit () {
      await this.$refs.bindForm.validate()
      if (this.isRegister) {
        if (!this.isBind) {
          try {
            this.state.loginBtn = true
            const { data } = await bind({
              code: this.formData.captcha.replace(/ /g, ''),
              openId: this.openId,
              phone: this.formData.account
            })
            this.state.loginBtn = false

            const token = data.token_type + ' ' + data.access_token
            setToken(token)
            this.inviteMem('绑定成功!')
          } catch (error) {
            this.state.loginBtn = false
          }
        }
      } else {
        if (!this.formData.isAngree) {
          this.$message.warning('请先同意用户协议')
          return
        }
        if (!this.isBind) {
          try {
            this.state.loginBtn = true
            const { data } = await register({
              code: this.formData.captcha.replace(/ /g, ''),
              password: md5(this.formData.password),
              mobilePhone: this.formData.account,
              openId: this.openId
            })
            this.state.loginBtn = false

            const token = data.token_type + ' ' + data.access_token
            setToken(token)
            this.inviteMem('注册并绑定成功!')
          } catch (error) {
            this.state.loginBtn = false
          }
        }
      }
    },
    // 获取验证码
    getCaptcha (e) {
      e.preventDefault()
      const errorArr = []
      this.$refs.bindForm.validateField(
        ['account', 'password', 'repassword'],
        async (errorMsg) => {
          if (!errorMsg) {
            errorArr.push(errorMsg)
            if (
              this.type === 1 ||
              (this.type === 2 &&
                errorArr.length === 3 &&
                errorArr.every((item) => item === ''))
            ) {
              if (
                (this.type === 1 && (!this.isRegister || this.isBind)) ||
                (this.type === 2 && (this.isRegister || this.isBind))
              ) {
                return
              }
              this.state.smsSendBtn = true

              const interval = window.setInterval(() => {
                // eslint-disable-next-line no-plusplus
                if (this.state.time-- <= 0) {
                  this.state.time = 60
                  this.state.smsSendBtn = false
                  window.clearInterval(interval)
                }
              }, 1000)

              try {
                await getSmsCaptcha({
                  type: this.isRegister ? 'feige_bind' : 'feige_register',
                  mobilePhone: this.formData.account
                })
                this.$message.success('验证码已发送')
              } catch (error) {
                clearInterval(interval)
                this.state.time = 60
                this.state.smsSendBtn = false
              }
            }
          }
        }
      )
    },
    // 跳转到二维码界面
    gotoLogin () {
      this.$emit('showQrCodeMsg')
    },
    onClickRule () {
      this.$emit('showRulesMsg')
    }
  }
}
</script>

<style lang="scss">
.bindingAccount {
  .el-input--prefix .el-input__inner {
    height: 40px;
    background: rgba(255, 255, 255, 0.05);
    // padding-left: 35px;
  }
  .el-input__inner {
    border: 1px solid #fff;
  }
  .el-input .el-input__inner:hover {
    border-color: #0094d9;
  }
  .el-input .el-input__inner::placeholder {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  .el-checkbox .el-checkbox__input .el-checkbox__inner {
    border: 1px solid transparent;
  }
  .el-input__prefix {
    top: 3px;
    left: 10px;
  }
}
</style>
<style lang="scss" scoped>
.bindingAccount {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  // width: 384px;
  // height: 485px;
  // box-shadow: 0 0 25px 2px #4ea2c9;
  // border: 2px solid rgba(78, 162, 201, 0.8);
  // border-radius: 24px;
  // background-color: rgba(255, 255, 255, 0.13);
  backdrop-filter: blur(5px);

  width: 424px;
  height: 542px;
  background: url("~@/assets/images/bg2.png") no-repeat;
  background-size: contain;
  .header {
    position: relative;
    margin: 32px 0 41px 0;
  }
  .title {
    font-size: 24px;
    font-family: Source Han Sans SC;
    color: #ffffff;
    text-shadow: 0px 3px 9px rgba(93, 204, 255, 1),
      0px 2px 17px rgba(77, 199, 255, 1);
    text-align: center;
  }
  .close-btn {
    position: absolute;
    right: 6px;
    top: -27px;
    width: 47px;
    height: 47px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba($color: #4d9fc6, $alpha: 0.5);
    box-shadow: 1px 2px 9px 1px rgba(0, 0, 0, 0.1);
    border-radius: 0px 24px 1px 24px;
    text-align: center;
    line-height: 60px;
    svg {
      font-size: 24px;
      color: #49b8ff;
      cursor: pointer;
    }
  }
  .user-layout-login {
    margin: 0px 42px;
    .agreement {
      margin-bottom: 10px;
      text-align: left;
    }
    .login-button {
      margin-top: 10px;
      width: 100%;
      height: 40px;
      font-size: 18px !important;
      border-radius: 6px;
    }
    .getCaptcha {
      width: 110px;
      height: 40px;
      background: rgba(255, 255, 255, 0.2) !important;
      border: unset !important;
      border-radius: 6px;
    }
    .show-password {
      margin: 14px 6px 0 0;
      color: #999;
      cursor: pointer;
      &:hover {
        color: $hover-color;
      }
    }
    svg {
      color: #aaa;
      font-size: 16px;
    }
    .text-button {
      display: flex;
      justify-content: flex-end;
      span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #00a4f0;
        cursor: pointer;
      }
    }
    .user-rule-button {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #00a4f0;
      cursor: pointer;
    }
  }
}
</style>
